import { OnInit, Component, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PharmacyService } from '../../../services/pharmacyservice';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { PharmacyStoreComponent } from '../pharmacy-store/pharmacy-store.component';
import { PharmacyCRUDModel } from '../../DTO/pharmacy-crud';
import { PharmacyStoreModel } from '../../DTO/pharmacy-store-crud';
import { PharmacySearchModel } from '../../DTO/pharmacy-search';
import { formatDate } from "@angular/common";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {MatExpansionModule} from '@angular/material/expansion';
import * as XLSX from 'xlsx';
import { VendorDropdownData, Vendor } from '../../DTO/vendor';
import { VendorService } from 'src/app/services/vendorservice';
import { ConnectionDetailsComponent } from '../../connection/connection-details/connection-details.component';

@Component({
  selector: 'app-pharmacy-update',
  templateUrl: './pharmacy-update.component.html',
  styleUrls: ['./pharmacy-update.component.css']
})
export class PharmacyUpdateComponent implements OnInit {
  isLoading: boolean = false;
  form: FormGroup;
  PharmacyId: FormControl;
  PharmacyName: FormControl;
  EffectiveDate: FormControl;
  TermDate: FormControl;
  IsEnabled: FormControl;
  PetEnabled: FormControl;
  BillingGroup: FormControl;
  BillingRegion: FormControl;
  PID: FormControl;
  Vendor: FormControl;
  pharmacyModel= new PharmacyCRUDModel();
  pharmacyFilter:string='';
  pharmacyId:string='';
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  useOkta:boolean=false;
  displayedColumns: string[] = ['NCPDPID', 'RecordActiveDate', 'RecordDeactivateDate','delete'];
  dataSource: any;
  userName: string='';
  // minEffectiveDate:Date;
  minTermDate:Date=new Date();
  pharmacyStoreModel= new PharmacyStoreModel();
  ncpdpid:string='';
  invalidTermDateError='';
  vendorList:any;
  useVendorLevelConnectivityToggle = false;
  connectionMessage:string='';
  VendorIsConnectivitySet = false;
  UseVendorConnectionDetails: FormControl;
  @ViewChild(ConnectionDetailsComponent) connectionDetailsComponent: ConnectionDetailsComponent;

  //initialEffectiveDate:Date;
  constructor(private pharmacyService: PharmacyService, private vendorService: VendorService, private toastr:ToastrService,
    public dialog: MatDialog,private router: Router, private route: ActivatedRoute,
    private modalService: NgbModal, private cdr: ChangeDetectorRef ) {
      this.route.paramMap.subscribe((params) => {
        this.pharmacyId = params.get('id');
      });
  }

  ngOnInit() {
    //this.minTermDate.setDate(new Date().getDate()+1);
    this.pharmacyModel.PharmacyEndpointURL = this.pharmacyModel.PharmacyEndpointURL || "";
    this.createFormControls();
    this.createForm();
    this.LoadVendors();
    this.userName = localStorage.getItem("loggedName");
    let div=document.getElementById('mat_sidenav_content') as HTMLDivElement;
    div.classList.remove("custom-content-default");
    div.classList.add("custom-content-update-pharmacy");
    this.form.get('Vendor')?.valueChanges.subscribe(vendorId => {
      const vendor = this.vendorList.find((v: Vendor) => String(v.VendorId) === vendorId);
      this.VendorIsConnectivitySet = vendor?.IsConnectivitySet?.toString().toLowerCase() === 'true';
      this.cdr.detectChanges(); // ensure UI updates
    });
    this.evaluateVendorConnectivityConfiguration();
  }

  ngOnDestroy() {
    let div=document.getElementById('mat_sidenav_content') as HTMLDivElement;
    div.classList.remove("custom-content-update-pharmacy");
    div.classList.add("custom-content-default");
  }

  createFormControls() {
    this.PharmacyId = new FormControl();
    this.PharmacyName = new FormControl('', [Validators.required, Validators.maxLength(50)]);
    this.EffectiveDate = new FormControl({value: new Date(new Date().toDateString()),disabled:true}, Validators.required);
    this.TermDate = new FormControl();
    this.IsEnabled = new FormControl();
    this.PetEnabled = new FormControl(false);
    this.BillingGroup = new FormControl('', [Validators.maxLength(4),Validators.pattern("[0-9]+$")]);
    this.BillingRegion = new FormControl('', [Validators.maxLength(2),Validators.pattern("[0-9]+$")]);
    this.PID = new FormControl('', [Validators.required,Validators.maxLength(20),Validators.pattern("^[a-zA-Z0-9]*$")]);
    this.Vendor = new FormControl();
    this.UseVendorConnectionDetails = new FormControl(false);
  }

  createForm() {
    this.form = new FormGroup({
      PharmacyId: this.PharmacyId,
      PharmacyName: this.PharmacyName,
      EffectiveDate: this.EffectiveDate,
      TermDate: this.TermDate,
      IsEnabled: this.IsEnabled,
      PetEnabled: this.PetEnabled,
      BillingGroup: this.BillingGroup,
      BillingRegion: this.BillingRegion,
      PID: this.PID,
      Vendor: this.Vendor,
      UseVendorConnectionDetails: this.UseVendorConnectionDetails
    });
  }

  get errorMessageForPharmacyName(): string {
    const pharmacyform: FormControl = (this.form.get('PharmacyName') as FormControl);
    return pharmacyform.hasError('required') ?
      'Pharmacy chain name is required' :
      pharmacyform.hasError('maxlength') ?
      'Max length is 50 characters' :
      pharmacyform.hasError('duplicate') ?
      'Pharmacy chain name already exist' :"" 
  }

  // get errorMessageForEffectiveDate():string{
  //   const pharmacyform: FormControl = (this.form.get('EffectiveDate') as FormControl);
  //   return pharmacyform.hasError('matDatepickerParse') ?
  //   'Invalid date' :
  //   pharmacyform.hasError('required') ?
  //   'Activation date is required' :
  //   pharmacyform.hasError('date error') ?
  //   'Activation date should be less than deactivation date': 
  //   pharmacyform.hasError('min date') ?
  //   'Activation date should be greater than equal to initial activation date':""
  // }

  get errorMessageForTermDate():string{
    const pharmacyform: FormControl = (this.form.get('TermDate') as FormControl);
    return pharmacyform.hasError('matDatepickerParse') ?
    'Invalid date' :
    pharmacyform.hasError('date error') ?
    'Deactivation date should be greater than activation date':""
  }

  get errorMessageForBillingGroup(): string {
    const pharmacyform: FormControl = (this.form.get('BillingGroup') as FormControl);
    return pharmacyform.hasError('maxlength') ?
      'Max length is 4 characters' :
      pharmacyform.hasError('pattern') ?
      'Please enter only numeric values' :"" 
  }

  get errorMessageForBillingRegion(): string {
    const pharmacyform: FormControl = (this.form.get('BillingRegion') as FormControl);
    return pharmacyform.hasError('maxlength') ?
      'Max length is 2 characters' :
      pharmacyform.hasError('pattern') ?
      'Please enter only numeric values' :"" 
  }

  get errorMessageForIsEnabled(): string {
    const pharmacyform: FormControl = (this.form.get('IsEnabled') as FormControl);
    return pharmacyform.hasError('invalid-termdate') ?
      this.invalidTermDateError :"" 
  }

  get errorMessageForPID(): string {
    const pharmacyform: FormControl = (this.form.get('PID') as FormControl);
    return pharmacyform.hasError('required') ?
      'PID is required' :
      pharmacyform.hasError('maxlength') ?
      'Max length is 20 characters' :
      pharmacyform.hasError('pattern') ?
      'Please enter only alpha numeric values' : 
      pharmacyform.hasError('duplicate') ?
      'PID already exist' :"" 
  }

  get errorMessageForVendor():string{
    const vendorform: FormControl = (this.form.get('Vendor') as FormControl);
    return vendorform.hasError('required') ?
      'Vendor is required' :""
  }

  clearPharmacyNameDuplicateValidation(){
    this.PharmacyName.setErrors({'duplicate': null});
    this.PharmacyName.updateValueAndValidity();
  }

  clearPIDDuplicateValidation(){
    this.PID.setErrors({'duplicate': null});
    this.PID.updateValueAndValidity();
  }

  dateValidation(targetElement:any)
  {
     let effectiveDate=new Date(Date.parse(this.form.get('EffectiveDate')?.value))
     let termDate=new Date(Date.parse(this.form.get('TermDate')?.value))
     this.clearValidation();
     //if(targetElement=="EffectiveDate"){
      // this.EffectiveDate.setErrors({'min date': null})
      // this.EffectiveDate.updateValueAndValidity();
      // if(effectiveDate<new Date(new Date().setHours(0,0,0,0))) {
      // if(effectiveDate<new Date(this.initialEffectiveDate.setHours(0,0,0,0))) {
      //   this.EffectiveDate.setErrors({'min date': true});
      //   this.form.get('EffectiveDate')?.markAsTouched();
      //   return;
      // }
     //}
    
      if(this.form.get('TermDate')?.value!=null &&
      this.form.get('EffectiveDate')?.value!=null && 
      effectiveDate>=termDate)
      {
        //this.EffectiveDate.setErrors({'date error': true});
        this.TermDate.setErrors({'date error': true});
        //this.form.get('EffectiveDate')?.markAsTouched();
        this.form.get('TermDate')?.markAsTouched();
      }
  }

  clearValidation(){
    //this.EffectiveDate.setErrors({'min date': null})
    //this.EffectiveDate.setErrors({'date error': null});
    this.TermDate.setErrors({'date error': null});
    //this.EffectiveDate.updateValueAndValidity();
    this.TermDate.updateValueAndValidity();
  }

  onDateInputkeyup(event:any)
  {
    //this.form.get('EffectiveDate')?.markAsTouched();
    this.form.get('TermDate')?.markAsTouched();
    this.dateValidation(event.targetElement.name);
    // if(event.targetElement.name=="TermDate"){
    //   this.enabledValidation();
    // }
    this.enabledValidation();
  }

  onDateSelect(event:any){
    // if(event.targetElement.name=="EffectiveDate"){
    //   this.minTermDate.setDate(new Date(Date.parse(this.form.get('EffectiveDate')?.value)).getDate()+1);
    // }
    // else{
    //   this.enabledValidation();
    // }
    this.enabledValidation();
    this.dateValidation(event.targetElement.name);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  submitForm(){
    if (this.form.valid) {
      this.connectionDetailsComponent?.setModelAttributes();
      this.isLoading = true;
      let basicPassword = this.form.get('BasicPassword')?.value.trim()==''? this.pharmacyModel.HiddenPassword: "**********";
      let oktaClientSecret = this.form.get('OktaClientSecret')?.value.trim()==''? this.pharmacyModel.HiddenClientSecret: "**********";
      this.getPharmacyModel();
      
      // if password is unchanged from existing password, set it to hidden value
      this.pharmacyModel.BasicPassword = this.pharmacyModel.BasicPassword=='' && this.pharmacyModel.HiddenPassword == "**********" ? this.pharmacyModel.HiddenPassword: this.pharmacyModel.BasicPassword;
      this.pharmacyModel.OktaClientSecret = this.pharmacyModel.OktaClientSecret=='' && this.pharmacyModel.HiddenClientSecret == "**********" ? this.pharmacyModel.HiddenClientSecret: this.pharmacyModel.OktaClientSecret;

      delete this.pharmacyModel.NCPDPIDs; // remove from the model
      this.pharmacyService.updatePharmacy(this.pharmacyModel).subscribe(res => {
        this.isLoading = false;
        if(res.ResponseStatus=='1'){
          this.pharmacyModel.HiddenPassword = basicPassword;
          this.pharmacyModel.HiddenClientSecret = oktaClientSecret;
          this.toastr.success('Pharmacy chain updated successfully');
        }
        else if(res.ResponseStatus=='0' && res.ResponseMessage!=''){
          this.toastr.error(res.ResponseMessage);
        }
      },(error: any)=>{
        this.isLoading=false;
        if(Array.isArray(error)){
          for (var err of error){
            if(err.ErrorMessage=='Pharmacy Duplicate'){
              this.PharmacyName.setErrors({'duplicate': true});
              this.form.get('PharmacyName')?.markAsTouched();
            }
            else if(err.ErrorMessage=='PID Duplicate'){
              this.PID.setErrors({'duplicate': true});
              this.form.get('PID')?.markAsTouched();
            }
          }
        }
        else if(error=='Pharmacy Duplicate'){
          this.PharmacyName.setErrors({'duplicate': true});
          this.form.get('PharmacyName')?.markAsTouched();
        }
        else if(error=='PID Duplicate'){
          this.PID.setErrors({'duplicate': true});
          this.form.get('PID')?.markAsTouched();
        }
        else{
          this.toastr.error(error);
        }
      });
    }
  }










  updateVendorConnectivityFlag(): void {
    const selectedVendorId = this.form.get('Vendor')?.value;
    const selectedVendor = this.vendorList?.find((v: Vendor) => v.VendorId === selectedVendorId);
    this.VendorIsConnectivitySet = selectedVendor?.IsConnectivitySet?.toString().toLowerCase() === 'true';
  }

  toggleVendorLevelConnectivity(isVendorLevel: boolean): void {
    setTimeout(() => {
      this.useVendorLevelConnectivityToggle = isVendorLevel;
      this.updateVendorConnectivityFlag();

      const selectedVendorId = this.form.get('Vendor')?.value;
      if (this.useVendorLevelConnectivityToggle) {
        if (!selectedVendorId) {
          this.connectionMessage = "Please select a Vendor before enabling vendor-level connectivity.";
          this.toastr.warning(this.connectionMessage);
        } else if (!this.VendorIsConnectivitySet) {
          this.connectionMessage = "Vendor connectivity settings are missing. Please complete the configuration on the 'Vendor' page before proceeding.";
          this.toastr.warning(this.connectionMessage, '', { timeOut: 10000 });
        } else {
          this.connectionMessage = '';
        }
      } else {
        this.connectionMessage = '';
      }
    }, 0);
  }

  isUpdateButtonDisabled(): boolean {
    if (this.useVendorLevelConnectivityToggle) {
      return !this.form.valid ||
            !this.VendorIsConnectivitySet ||
            !this.form.get('Vendor')?.value;
    } else {
      const panelOpen = this.connectionDetailsComponent?.panelOpenState;
      const connectionFormValid = this.connectionDetailsComponent?.form?.valid;

      // ✅ Only validate connection form if panel is open
      const connectionFormInvalid = panelOpen && !connectionFormValid;
      return !this.form.valid || connectionFormInvalid;
    }
  }


  getPharmacyModel(){
    if (this.useVendorLevelConnectivityToggle) {
      this.pharmacyModel.IsVendorConnectionEnabled = 'true';
    }
    else
    {
      this.pharmacyModel.IsVendorConnectionEnabled = 'false';
    }

    // Reset connectionDetailsComponent binding
    if (!this.connectionDetailsComponent?.panelOpenState) {
      // if toggle is OFF
      this.pharmacyModel.IsConnectivitySet = "false";

      // Clear BASIC credentials
      this.pharmacyModel.BasicUserName = "";
      this.pharmacyModel.BasicPassword = "";
      this.pharmacyModel.HiddenPassword = "";

      // Clear OKTA credentials
      this.pharmacyModel.OktaClientId = "";
      this.pharmacyModel.OktaClientSecret = "";
      this.pharmacyModel.OktaAuthURL = "";
      this.pharmacyModel.HiddenClientSecret = "";
      this.pharmacyModel.OktaMckClientId = "";

      // Clear endpoint
      this.pharmacyModel.PharmacyEndpointURL = "";

    }
    else {
      // if toggle is ON
      this.pharmacyModel.IsConnectivitySet = "true";
    }

    //let basicPassword = this.form.get('BasicPassword')?.value.trim()==''? this.pharmacyModel.HiddenPassword: btoa(this.form.get('BasicPassword')?.value.trim());
    //this.pharmacyModel=new PharmacyCRUDModel();
    this.pharmacyModel.PharmacyId = this.pharmacyId;
    this.pharmacyModel.PharmacyName = this.form.get('PharmacyName')?.value;
    this.pharmacyModel.VendorId = this.form.get('Vendor')?.value;
    this.pharmacyModel.EffectiveDate =formatDate(this.form.get('EffectiveDate')?.value, 'yyyy-MM-dd', 'en-US');
    if(this.form.get('TermDate')?.value!=null){
      this.pharmacyModel.TermDate =formatDate(this.form.get('TermDate')?.value, 'yyyy-MM-dd', 'en-US');
    }
    else{
      this.pharmacyModel.TermDate =null;
    }
    this.pharmacyModel.IsEnabled = this.form.get('IsEnabled')?.value==true?"1":"0";
    this.pharmacyModel.PetEnabled = this.form.get('PetEnabled')?.value==true?"1":"0";
    this.pharmacyModel.BillingGroup = this.form.get('BillingGroup')?.value;
    this.pharmacyModel.BillingRegion = this.form.get('BillingRegion')?.value;
    // this.pharmacyModel.PharmacyEndpointURL = this.form.get('PharmacyEndpointURL')?.value;
    // this.pharmacyModel.OktaMckClientId = this.form.get('OktaMckClientId')?.value;
    // this.pharmacyModel.AuthType = this.form.get('AuthType')?.value;
    // if(this.pharmacyModel.AuthType=="OKTA") {
    //   this.pharmacyModel.OktaAuthURL = this.form.get('OktaAuthURL')?.value;
    //   this.pharmacyModel.OktaClientId = this.form.get('OktaClientId')?.value;
    //   if(this.form.get('OktaClientSecret')?.value)
    //     this.pharmacyModel.OktaClientSecret = btoa(this.form.get('OktaClientSecret')?.value);
    //   //this.pharmacyModel.OktaClientSecret = this.form.get('OktaClientSecret')?.value;
    // }
    // else {
    //   if(this.form.get('BasicUserName')?.value)
    //     this.pharmacyModel.BasicUserName = btoa(this.form.get('BasicUserName')?.value);
    //   if(this.form.get('BasicPassword')?.value)
    //     this.pharmacyModel.BasicPassword = btoa(this.form.get('BasicPassword')?.value);
    //   //this.pharmacyModel.BasicUserName = this.form.get('BasicUserName')?.value;
    //   //this.pharmacyModel.BasicPassword = this.form.get('BasicPassword')?.value;
    // }
    this.pharmacyModel.PID = this.form.get('PID')?.value;
    this.pharmacyModel.UpdatedBy=this.userName;
  }

  showNCPDPIDPopup(){
    this.pharmacyStoreModel.PharmacyId=this.pharmacyId;
    const dialogRef = this.dialog.open(PharmacyStoreComponent, {
      width: '520px',
      height: '720px',
      data: this.pharmacyStoreModel
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadPharmacyDetails();
    });
  }
  onClickCancel(){
    this.router.navigate(['searchpharmacy']);
  }
  ExportToExcel()
  {
    if(this.pharmacyModel.NCPDPIDs.NCPDPIDs.length>0)
    {
      let PharmacyNcpdpidArray: any[]=[];
      this.pharmacyModel.NCPDPIDs.NCPDPIDs.forEach((obj: any)=> {
        PharmacyNcpdpidArray.push({"Pharmacy NCPDP ID": "\t" +obj['NCPDPID'],
          "Record Active Date": "\t" + (obj['RecordActiveDate'] ?? ''),
          "Record Deactivate Date": "\t" + (obj['RecordDeactivateDate'] ?? '')
        });
       });
      const pharmacy: XLSX.WorkSheet = XLSX.utils.json_to_sheet(JSON.parse(JSON.stringify(PharmacyNcpdpidArray)));
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, pharmacy, 'Pharmacy Stores');
      XLSX.writeFile(wb, this.pharmacyModel.PharmacyName+'.csv');
    }
    else{
      this.toastr.error("No NCPDP IDs to export");
    }
  }
  loadPharmacyDetails(){
    this.isLoading=true;
    this.pharmacyModel.PharmacyId =  this.pharmacyId;
    let pharmacyLookupRequest= new PharmacyCRUDModel();
    pharmacyLookupRequest.PharmacyId =  this.pharmacyId;
    this.pharmacyService.getPharmacyDetails(pharmacyLookupRequest).subscribe(res=>{
      if(res.BasicUserName)
        res.BasicUserName = atob(res.BasicUserName);
      if(res.BasicPassword)
        res.BasicPassword = atob(res.BasicPassword);
      this.pharmacyModel = res;
      this.setFormValues();
      let ncpdpids:any=res.NCPDPIDs?.NCPDPIDs;
      this.dataSource = new MatTableDataSource(ncpdpids);
      this.isLoading = false;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filter = this.pharmacyFilter.trim().toLowerCase();
      this.isLoading=false;
      
      // Resolve AuthType to ensure it is not null or empty
      // If it is null or empty, default to 'BASIC'
      const resolvedAuthType = res.AuthType?.trim() || 'BASIC';
      res.AuthType = resolvedAuthType;
      this.connectionDetailsComponent.useOkta = resolvedAuthType === 'OKTA';

      
      // bind Vendor's IsConnectivitySet flag
      const selectedVendorId = String(res.VendorId).trim();
      const selectedVendor = this.vendorList?.find((v: Vendor) => String(v.VendorId) === selectedVendorId);
      if (selectedVendor) {
        this.VendorIsConnectivitySet = selectedVendor.IsConnectivitySet?.toString().toLowerCase() === 'true';
      } else {
        this.VendorIsConnectivitySet = false;
      }

      // bind Pharmacy's is_vendor_connection_enabled flag
      const isVendorConnectionEnabled = String(res.IsVendorConnectionEnabled).toLowerCase() === 'true';
      this.useVendorLevelConnectivityToggle = isVendorConnectionEnabled;
      this.form.get('UseVendorConnectionDetails')?.setValue(isVendorConnectionEnabled);

      const isVendorConnectivityEnabled = String(res.IsVendorConnectionEnabled).toLowerCase() === 'true';
      const isPharmacyConnectivityEnabled = String(res.IsConnectivitySet).toLowerCase() === 'true';

      this.useVendorLevelConnectivityToggle = isVendorConnectivityEnabled;
      this.form.get('UseVendorConnectionDetails')?.setValue(isVendorConnectivityEnabled);

      // ✅ Only open panel if Pharmacy-Level is selected AND connectivity is enabled
      this.connectionDetailsComponent.panelOpenState = !isVendorConnectivityEnabled && isPharmacyConnectivityEnabled;
      this.evaluateVendorConnectivityConfiguration();
      this.cdr.detectChanges();
      this.isLoading = false;
 },(error: any)=>{
      this.isLoading=false;
      this.toastr.error(error);
    });
  }

  onVendorChange(vendorId: any): void {
    const selectedVendorIdStr = String(vendorId).trim();
    const selectedVendor = this.vendorList?.find((v: Vendor) => String(v.VendorId) === selectedVendorIdStr);

    // Update connectivity flag
    this.VendorIsConnectivitySet = selectedVendor?.IsConnectivitySet?.toString().toLowerCase() === 'true';

    // Reset the toggle
    this.useVendorLevelConnectivityToggle = false;
    this.form.get('UseVendorConnectionDetails')?.setValue(false, { emitEvent: false });

    // Clear any previous warning messages
    this.connectionMessage = '';

    // Update form validation
    this.Vendor.updateValueAndValidity();

    // UI to re-evaluate bindings
    this.cdr.detectChanges();
  }

  evaluateVendorConnectivityConfiguration(): void {
    if (this.useVendorLevelConnectivityToggle && !this.VendorIsConnectivitySet) {
      this.connectionMessage = "Vendor connectivity settings are missing. Please complete the configuration on the 'Vendor' page before proceeding.";
      this.toastr.warning(this.connectionMessage, '', { timeOut: 10000 });
    } else if (this.pharmacyModel.IsConnectivitySet?.toString().toLowerCase() === 'true') {
      this.connectionMessage = '';
    }
  }

  get isVendorConnectivityValid(): boolean {
    return this.useVendorLevelConnectivityToggle && String(this.VendorIsConnectivitySet).toLowerCase() === 'true';
  }

  setFormValues() {
    this.PharmacyId.setValue(this.pharmacyModel.PharmacyId);
    this.PharmacyName.setValue(this.pharmacyModel.PharmacyName);
    this.Vendor.setValue(this.pharmacyModel.VendorId);
    // this.minEffectiveDate = (new Date(Date.parse(this.pharmacyModel.EffectiveDate)));
    // this.initialEffectiveDate=new Date(Date.parse(this.pharmacyModel.EffectiveDate));
    this.EffectiveDate.setValue(new Date(Date.parse(this.pharmacyModel.EffectiveDate)));
    this.minTermDate = (new Date(Date.parse(this.form.get('EffectiveDate')?.value)));
    this.minTermDate.setDate(this.minTermDate.getDate()+1);
    if (this.pharmacyModel.TermDate) {
      this.TermDate.setValue(new Date(Date.parse(this.pharmacyModel.TermDate)));
      //this.TermDate.setErrors({'min date': null})
    }
    else {
      this.TermDate.setValue(null);
    }
    this.IsEnabled.setValue(this.pharmacyModel.IsEnabled=='1'?true:false);
    //this.enabledValidation();
    this.PetEnabled.setValue(this.pharmacyModel.PetEnabled=='1'?true:false);
    this.BillingGroup.setValue(this.pharmacyModel.BillingGroup);
    this.BillingRegion.setValue(this.pharmacyModel.BillingRegion);
    if(this.pharmacyModel.AuthType=='OKTA'){
      this.useOkta=true;
    }
    this.PID.setValue(this.pharmacyModel.PID);
  }

  deleteNCPDPID(ncpdpid:string){
    this.isLoading=true;
    this.pharmacyStoreModel.NCPDPID = ncpdpid;
    this.pharmacyStoreModel.UpdatedBy = this.userName;
    this.pharmacyService.deletePharmacyStore(this.pharmacyStoreModel).subscribe(res=>{
      this.isLoading = false;
      if(res.ResponseStatus==true){
        this.loadPharmacyDetails();
        this.toastr.success('Pharmacy store deleted successfully');
      }
      else if(res.ResponseStatus==false && res.ResponseMessage!=''){
        this.toastr.error(res.ResponseMessage);
      }
    },(error: any)=>{
      this.isLoading=false;
      this.toastr.error(error);
    });
  }

  open(content: any, ncpdpid: any) {
    this.ncpdpid =ncpdpid;
    this.modalService.open(content, { 
      ariaLabelledBy: 'modal-basic-title',
      backdropClass: 'backdropCustom'

    }).result.then((result) => {
      if (result === 'yes') {
        this.deleteNCPDPID(ncpdpid);
      }
    }, (reason) => {
    });
  }

  onEnabledChange(event:any){
    this.enabledValidation();
  }

  enabledValidation(){
    let termDate=new Date(Date.parse(this.form.get('TermDate')?.value))
    this.IsEnabled.setErrors({'invalid-termdate': null});
    this.IsEnabled.updateValueAndValidity();
    if(this.form.get('IsEnabled')?.value && this.form.get('TermDate')?.value!=null && termDate<=new Date(new Date().setHours(0,0,0,0))){
      this.invalidTermDateError="Deactivation date should be greater than today";
      this.IsEnabled.setErrors({'invalid-termdate': true});
      this.form.get('IsEnabled')?.markAsTouched();
    }
    // else if (!this.form.get('IsEnabled')?.value && (this.form.get('TermDate')?.value==null ||
    //  termDate>new Date(new Date().setHours(0,0,0,0)))){
    else if (!this.form.get('IsEnabled')?.value && termDate.toString()!=new Date(new Date().setHours(0,0,0,0)).toString()){
      // this.invalidTermDateError="Deactivation date should not be empty or greater than today";
      this.invalidTermDateError="Deactivation date should be today's date";
      this.IsEnabled.setErrors({'invalid-termdate': true});
      this.form.get('IsEnabled')?.markAsTouched();
    }
    // else if (!this.form.get('IsEnabled')?.value && (this.form.get('TermDate')?.value==null ||
    //  termDate.toString()!=new Date(new Date().setHours(0,0,0,0)).toString())){
    //   this.invalidTermDateError="Deactivation date should be today date";
    //   this.IsEnabled.setErrors({'invalid-termdate': true});
    //   this.form.get('IsEnabled')?.markAsTouched();
    // } 
  }

  onBillingGroupChange(event:any){
    let leadingZeros = "";
    if (event.target.value.length==1){
      leadingZeros = "000";
    }
    else if (event.target.value.length==2){
      leadingZeros = "00";
    }
    else if (event.target.value.length==3){
      leadingZeros = "0";
    }
    this.form.get('BillingGroup')?.setValue(leadingZeros+this.form.get('BillingGroup')?.value);
  }

  onBillingRegionChange(event:any){
    if (event.target.value.length==1){
      this.form.get('BillingRegion')?.setValue("0"+this.form.get('BillingRegion')?.value);
    }
  }

  LoadVendors() {
    this.vendorService.getVendors().subscribe(res => {
      this.vendorList = VendorDropdownData.vendorList;
      this.loadPharmacyDetails(); 
    });
  }

  showConnectionDetails(): boolean {
    return !(this.useVendorLevelConnectivityToggle);
  }
}

